import { Navigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { SubscriptionPlansPanel } from "@/components/subscription-plans-panel";
import { useAuthStore } from "@/stores/authStore";
import { fetchSubscriptionPlans } from "@/services/api/subscriptions";

export function TenantSubscriptionsPage() {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  const t = useTranslations("subscriptions");
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const plansQuery = useQuery({
    queryKey: ["subscription-plans", tenantSlug],
    queryFn: fetchSubscriptionPlans,
    enabled: isAuthenticated,
  });

  if (!isAuthenticated) {
    return <Navigate to={`/t/${tenantSlug}/login`} replace />;
  }

  return (
    <main
      className="mx-auto flex min-h-[calc(100dvh-14rem)] w-full max-w-3xl flex-1 flex-col px-4 py-10 pb-20"
      data-testid="subscriptions-page"
    >
      <h1 className="font-serif text-2xl font-semibold text-[var(--brand-heading)]">
        {t("title")}
      </h1>
      <p className="mt-2 text-[var(--brand-muted)]">{t("subtitle")}</p>
      <div className="mt-8 flex-1">
        {plansQuery.isLoading ? (
          <p className="text-sm text-[var(--text-muted)]">{t("loading")}</p>
        ) : (
          <SubscriptionPlansPanel
            tenantSlug={tenantSlug}
            plans={plansQuery.data ?? []}
            isLoggedIn={isAuthenticated}
          />
        )}
      </div>
    </main>
  );
}
